module.exports = __webpack_public_path__ + "img/B8.fa2f409b.png";